import React from "react";
import instance from "../../../../axios/instance";
import { getToken } from "../../../../utils/token";
import { useLoaderData } from "react-router-dom";
import { CircleDashed, DollarSign, HandCoins } from "lucide-react";
import EarningsChart from "../components/EarningsChart";
import TotalNumberCard from "../../../../components/cards/TotalNumberCard";

export const earningsOverviewLoader = async () => {
  const token = getToken();
  const balance = await instance.get("/doctor/connect/balance", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return {
    balance: balance.data,
  };
};

export const EarningsOverviewPage = () => {
  const { balance } = useLoaderData();

  return (
    <div className="mt-5">
      <div className="grid grid-cols-2 gap-x-3 gap-y-3 mb-5">
        <TotalNumberCard
          title="All time balance"
          value={`$${balance.total.toLocaleString()}`}
          icon={<DollarSign size={20} />}
          color="#3caf50"
          tooltip='Your all time balance'
          href='/dashboard/earnings/payments'
        />
        <TotalNumberCard
          title="Pending balance"
          value={`$${balance.pending.toLocaleString()}`}
          icon={<CircleDashed size={20} />}
          color="#F52F57"
          tooltip='Balance yet to be realised on your main balance'
          href='/dashboard/earnings/payments'
        />
      </div>
      <EarningsChart transactions={balance.transactions} subtitle={'Earnings'} title={'Earnings Overview'} yOriginTitle={'Earnings ($)'} value={null} />
    </div>
  );
};
